import SlabsTable from './table';
import { useSlabs } from './table/hooks/useSlabsList';

const Slabs = () => {
  const { slabs, isLoading, meta, search, pointCategoryId } = useSlabs();
  return (
    <SlabsTable
      data={slabs}
      isLoading={isLoading}
      pagination={meta}
      pointCategoryId={pointCategoryId}
      categoryName={search.categoryName}
    />
  );
};

export default Slabs;
